export enum TASK_STATUS {
  TODO = 'TO_DO',
  IN_QUOTATION = 'IN_QUOTATION',
  PLANNING = 'PLANNING',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_REVIEW = 'IN_REVIEW',
  DONE = 'DONE',
  WONT_DO = 'WONT_DO',
}

export enum PROJECT_STATUS {
  DRAFT = 'DRAFT',
  SENT_TO_CUSTOMER = 'SENT_TO_CUSTOMER',
  VALIDATED = 'VALIDATED',
  COMPLETED = 'COMPLETED',
}

export enum NotificationOperationProcessor {
  CNPS_DECLARATION_UNPAID = 'CNPS_DECLARATION_UNPAID',
}

export const EmailTemplateKeys = {
  [NotificationOperationProcessor.CNPS_DECLARATION_UNPAID]:
    'Templates/email/cnps-declaration-unpaid-reminder-email.html',
};
